import React from 'react';
import PropTypes from 'prop-types';
import ConnectedDataForm from './ConnectedDataForm';

const DataRouting = ({ match }) => <ConnectedDataForm />;

DataRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default DataRouting;
